import type { GeneralWidgetProps } from '../../../types';

import styles from './GeneralSmallWidget.module.scss';

export function GeneralSmallWidget(props: GeneralWidgetProps) {
  const { widgetImageUrl, timer } = props;
  const imgStyle = timer ? styles.imgExtended : styles.img;
  return (
    <div className={styles.container}>
      <img alt="" className={imgStyle} src={widgetImageUrl} />
      {timer}
    </div>
  );
}
